var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifi1 = function SvgWifi1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 12"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.091 6.598a7.2 7.2 0 0 0-2.336-1.656A6.8 6.8 0 0 0 8 4.36c-.946 0-1.882.198-2.755.582a7.2 7.2 0 0 0-2.336 1.656l1.454 1.544a5.1 5.1 0 0 1 1.669-1.184A4.9 4.9 0 0 1 8 6.543c.675 0 1.344.141 1.968.415a5.1 5.1 0 0 1 1.669 1.184z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.51C13.877 1.264 11 0 8 0S2.123 1.263 0 3.51l1.454 1.544C3.192 3.214 5.546 2.181 8 2.181s4.808 1.033 6.546 2.873z",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.943 9.817 8 12l2.057-2.183a2.9 2.9 0 0 0-.944-.67 2.76 2.76 0 0 0-2.226 0 2.9 2.9 0 0 0-.944.67"
  })));
};
export default SvgWifi1;